import React, { PropsWithChildren } from 'react';
import { FONT_FAMILY } from '../fonts/font';
import { AudiogramProps } from '../schema';

export const Background: React.FC<PropsWithChildren<AudiogramProps>> = (props) => {
  const { backgroundType, backgroundColor, backgroundImageUrl, variant, children } = props;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        color: 'white',
        padding: '48px',
        backgroundColor: backgroundType === 'solid' && backgroundColor ? backgroundColor : 'black',
        backgroundImage:
          backgroundType === 'image' && backgroundImageUrl
            ? `url(${backgroundImageUrl})`
            : undefined,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        fontFamily: FONT_FAMILY,
      }}
    >
      <div style={{}}>{children}</div>
    </div>
  );
};
